import {HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {UserManagementService} from "@backbase/data-ang/user";
import {catchError, map, switchMap} from "rxjs/operators";
import {GetOwnUser as UserInfo} from "@backbase/user-http-ang/model/getOwnUser";
import {Injectable} from "@angular/core";

@Injectable()
export class EventLoginInterceptor implements HttpInterceptor {
  constructor(
    protected httpClient: HttpClient,
    private readonly userService: UserManagementService) {
  }
  readonly $userInfo: Observable<UserInfo | undefined> = this.userService
    .getOwnUser()
    .pipe(catchError(() => of(undefined)));
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        switchMap(event => {
          if (req.url.indexOf('api/access-control/client-api/v2/accessgroups/usercontext') > -1 && req.method === 'POST') {
            if (event instanceof HttpResponse) {
              return this.$userInfo.pipe(
                  switchMap((user) => {
                    return user ? this.loginEvent(req.body?.serviceAgreementId, user.id) : of(undefined)
                  }),
                  map(() => event)
                );
            }
          }
          return of(event);
        })
      );
  }
  loginEvent(serviceagreementId: string, userId: string){
    return this.httpClient.post('/api/bss-event-listener/client-api/v2/loginevent', { serviceagreementId, userId });
  }
}
